import { type Attachment } from 'entities/Attachment/model/Attachment'

export const sortAttachmentsByDate = (a: Attachment, b: Attachment) => {
  if (!a.created_at) return -1
  if (!b.created_at) return 1

  return new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
}
